import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  SectionContainer,
} from './AuditThree.style';

const AuditThree = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditThree.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <div className="grid-content">
            <p>{t('auditThree.paragraphOne')}</p>
          </div>
          <div className="grid-content">
            <ul>
              <li>{t('auditThree.paragraphTwo.one')}</li>
              <li>{t('auditThree.paragraphTwo.two')}</li>
              <li>
                {t('auditThree.paragraphTwo.three.text')} "
                <span>{t('auditThree.paragraphTwo.three.spanOne')}</span>", "
                <span>{t('auditThree.paragraphTwo.three.spanTwo')}</span>", "
                <span>{t('auditThree.paragraphTwo.three.spanThree')}</span>", "
                <span>{t('auditThree.paragraphTwo.three.spanFour')}</span>", "
                <span>{t('auditThree.paragraphTwo.three.spanFive')}</span>", "
                <span>{t('auditThree.paragraphTwo.three.spanSix')}</span>"
              </li>
            </ul>
          </div>
          <div className="grid-content">
            <p>{t('auditThree.paragraphThree')}</p>
          </div>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditThree;
